import logo from "@/assets/sgbinoxe-logo.png";

export function Logo({ className = "", showText = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img src={logo} alt="SGBINOXE" className="h-full w-auto object-contain" draggable={false} />
      {showText && (
        <span className="font-display text-lg font-semibold tracking-tight text-white">
          Care
        </span>
      )}
    </div>
  );
}
